import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {Group} from '../../../graphql/groups.datatypes';
import {gqlGroup} from '../getGroup.api';
import {CreateGroupMemberVars} from '../GroupMemberDetails/createGroupMember.api';
import {UpdateGroupMemberVars} from '../GroupMemberDetails/updateGroupMember.api';

export interface UpdateGroupInput {
  data: {
    id: number
    tour_resource_id?: number
    hotel_resource_id?: number
    name?: string
    description?: string
    description_resort?: string
    description_whats_included?: string
    description_checkin?: string
    editing_level?: number
    start_date?: string
    end_date?: string
    admissions_cutoff?: string
    start_date_additional?: string
    end_date_additional?: string
    max_additional_nights?: number
    invoice_document_id?: number
    convenience_fee?: number
    credit_card_fee?: number
    comp_dollar_value?: number
    comp_ratio?: number
    comp_dollar_estimate?: number
    comp_final_value?: number
    default_authorize_members?: boolean
    validated?: boolean
    disabled?: boolean
    locked?: boolean
    booking_tool_edit_cutoff?: string
    description_insurance?: string

    members?: {
      create?: CreateGroupMemberVars[]
      update?: UpdateGroupMemberVars[]
      delete?: number[]
    }

    associatedUsers?: {
      connect?: number[]
      disconnect?: number[]
    }

    options?: {
      create?: Array<{
        resource_option_id: number,
        mandatory: boolean,
        editing_level: number,
        view_level: number,
      }>
      //update?: UpdateGroupMemberVars[]
      delete?: number[]
    }
  }
}

interface UpdateGroupData {
  __typename?: string,
  updateGroup: Group
}

export const UPDATE_GROUP_MUTATION = gql`
    mutation updateGroup($data: UpdateGroupInput!) {
        updateGroup(data: $data) {
            ${gqlGroup}
        }
    }
`;

export const updateGroup = () => useMutation<UpdateGroupData, UpdateGroupInput>(
  UPDATE_GROUP_MUTATION,
  {
    update: updateCacheByType('Group'),
  }
);

export default updateGroup;